class PaquesTrigger {
  constructor() {
    this.init();
  }

  init() {
   if (!this.isValidDate()) return;
    
    this.initPaquesClick();
    this.injectPaquesOeufCoffret();
    this.injectPaquesOeufSolaire();
    this.changeCollectionImg();
  }

isValidDate() {
  const today = new Date();
  const startDate = new Date('2025-04-20');
  const endDate = new Date('2025-05-01');

  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);
  today.setHours(0, 0, 0, 0);

  return today >= startDate && today <= endDate;
}


  initPaquesClick() {
    const elements = document.querySelectorAll('.paques');

    elements.forEach((el) => {
      el.style.cursor = 'pointer';
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.triggerPromo();
      });
    });
  }

  triggerPromo() {
    if (typeof promolayer !== 'undefined' && promolayer.triggerDisplay) {
       if (window.location.pathname.includes('le-coffret-toilette-quotidienne')){
         promolayer.triggerDisplay('rdq0Oarlv9QWJjQpPZ0e');
       } else if (window.location.href.includes('stick-solaire')){
         promolayer.triggerDisplay('uI5Fh36xvzPmVVXGcscM');
       }else {
         promolayer.triggerDisplay('uNZa7v2PMLx6ksLkFkRo');
       }
          
    } else {
      console.warn("promolayer n'est pas disponible.");
    }
  }

  createPaquesImageOeufVert() {
    const img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0454/4426/8187/files/vert_oeuf.gif?v=1744721321';
    img.alt = 'Œuf de Pâques';
    img.style.display = 'block';
    img.style.pointerEvents = 'none';
    img.style.width = '75px'
    return img;
  }

  createPaquesImageOeufJaune() {
    const img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0454/4426/8187/files/jaune_oeuf.gif?v=1744721333';
    img.alt = 'Œuf de Pâques';
    img.style.display = 'block';
    img.style.pointerEvents = 'none';
    img.style.width = '75px'
    return img;
  }

  createPaquesImageOeufBleu() {
    const img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0454/4426/8187/files/bleu_oeuf.gif?v=1744718142';
    img.alt = 'Œuf de Pâques';
    img.style.display = 'block';
    img.style.pointerEvents = 'none';
    img.style.width = '75px'
    return img;
  }

  injectPaquesOeufCoffret() {
    if (!window.location.pathname.includes('le-coffret-toilette-quotidienne')) return;

    console.log('oeuf vert')
    const titleWrapper = document.querySelector('.product__title');
    if (!titleWrapper || titleWrapper.classList.contains('paques-injected')) return;

    const paquesDiv = document.createElement('div');
    paquesDiv.classList.add('paques', 'paques_oeuf-container');
    paquesDiv.style.position = 'absolute';
    paquesDiv.style.right = '10%';
    paquesDiv.style.cursor = 'pointer';
    paquesDiv.style.zIndex = '999';

    const img = this.createPaquesImageOeufJaune();
    paquesDiv.appendChild(img);

    titleWrapper.insertAdjacentElement('afterend', paquesDiv);
    titleWrapper.classList.add('paques-injected');

    paquesDiv.addEventListener('click', (e) => {
      e.preventDefault();
      this.triggerPromo();
    });
  }

  injectPaquesOeufSolaire() {
  if (!window.location.href.includes('stick-solaire')) return;

  const descWrapper = document.getElementById('ProductAccordion-collapsible-row-0-template--16318511677670__main');
  if (!descWrapper || descWrapper.classList.contains('paques-injected')) return;

  const pTag = descWrapper.querySelector('p');
  if (!pTag) return;

  const paquesDiv = document.createElement('div');
  paquesDiv.classList.add('paques', 'paques_oeuf-container');
  paquesDiv.style.width = '100%';
  paquesDiv.style.display = 'flex';
  paquesDiv.style.justifyContent = "center";
  paquesDiv.style.cursor = 'pointer';
  paquesDiv.style.zIndex = '999';

  const img = this.createPaquesImageOeufBleu();
  paquesDiv.appendChild(img);

  pTag.insertAdjacentElement('afterend', paquesDiv);

  descWrapper.classList.add('paques-injected');

  paquesDiv.addEventListener('click', (e) => {
    e.preventDefault();
    this.triggerPromo();
  });
}

  changeCollectionImg(){
  if (!window.location.href.includes('collections/coffret')) return;
  console.log('changeImg')
  document.querySelectorAll('.card__media img').forEach(img => {
  if (img.src.includes('MicrosoftTeams-image_12.jpg')) {
    // Remplace l'image ici
    img.src = 'https://cdn.shopify.com/s/files/1/0454/4426/8187/files/FP_TOILETTE_QUOTIDIENNE.jpg?v=1744721309';
    img.srcset = '';
    img.alt = 'image op paques';
  }
});
}

  
}

document.addEventListener('DOMContentLoaded', () => {
  new PaquesTrigger();
});
